import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Checkbox } from "primereact/checkbox";
import { currentPageReportTemplate, onPageChange, paginatorTemplate } from "../../../utilities/TableUtil";
import { normalColumn ,numeralColumn} from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P233List_1({ dataTable, setDataClone, setSelected }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    const [globalFilter, setGlobalFilter] = useState(null);
    // CheckBox In Table
    const checkBoxColumn = (rowData, dataClone = [], titleShow, checkColumn, selected) => {
        let data = { ...rowData };
        let datavalue = data[`${checkColumn}`];

        const setFlag = () => {
            const flag = dataClone[data.index].flag;

            if (datavalue === "N") {
                if (flag === "N" && flag === "") {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (flag === "Y") {
                    return true;
                } else {
                    return false;
                }
            }
        };

        return (
            <React.Fragment>
                <span className="p-column-title">{titleShow}</span>
                <Checkbox onChange={(e) => selected(rowData, e.checked)} checked={setFlag()} disabled={datavalue === "N" ? true : false}></Checkbox>
            </React.Fragment>
        );
    };
    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={[5, 10, 25]}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูล"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="withdrawSeq" header="เลือก" body={(e) => checkBoxColumn(e, setDataClone, "เลือก", "seqEnableFlag", setSelected)} style={{ textAlign: "center", width: "3%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="p1Seq" header="P1 ครั้งที่" body={(e) => normalColumn(e, "p1Seq", "P1 ครั้งที่")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="routeName" header="เส้นทาง" body={(e) => normalColumn(e, "routeName", "เส้นทาง")} style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_LEFT} />
                    <Column field="deliveryAmount" header="จำนวนเงินรวมที่ส่งมอบงาน" body={(e) => numeralColumn(e, "deliveryAmount", "จำนวนเงินรวมที่ส่งมอบงาน")} style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="deliveryLetterNo" header="หนังสือส่งมอบงานเลขที่" body={(e) => normalColumn(e, "deliveryLetterNo", "หนังสือส่งมอบงานเลขที่")} style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="letterDate" header="ลงวันที่" body={(e) => normalColumn(e, "deliveryLetterDate", "ลงวันที่")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="p2Seq" header="P2 งวดที่" body={(e) => normalColumn(e, "p2Seq", "P2 งวดที่")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                </DataTable>
            </div>
        </div>
    );
}
